import { type OnboardingChatResults } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpdateMoneyMapFromReview = requestBuilder.mutation<
    null,
    OnboardingChatResults
>({
    endpoint: () => `/api/money-map/update-from-review`,
    method: 'POST',
});

export default useUpdateMoneyMapFromReview;
